@let loginLink = loginPageUrl();

<rt-dialog-header [heading]="'tlc.members.subdomain_information_dialog.heading' | translate" />
<rt-dialog-body variant="white">
  <div class="login-page-address">
    <img
      ngSrc="assets/images/tellent/security-lock.png"
      alt="security-lock"
      width="108"
      height="84"
    />
    <div class="text-container">
      <span
        [innerHTML]="'tlc.members.subdomain_information_dialog.login_page_address' | translate"
      ></span>
      <a [href]="loginLink" target="_blank">{{ loginLink }}</a>
    </div>
  </div>
  <div class="share-login-page">
    <div class="header-container">
      <div class="text-container">
        <span class="heading">{{
          'tlc.members.subdomain_information_dialog.share_box.heading' | translate
        }}</span>
        <span class="subheading">{{
          'tlc.members.subdomain_information_dialog.share_box.subheading' | translate
        }}</span>
      </div>
      <rt-button variant="tertiary" (click)="copyLink()">
        <rt-icon name="content-copy" />
        <span>{{ 'tlc.common.copy' | translate }}</span>
      </rt-button>
    </div>
    <div class="link-box">
      <span>{{
        'tlc.members.subdomain_information_dialog.share_box.login_page'
          | translate: { loginPageUrl: loginLink }
      }}</span>
      <span>{{
        'tlc.members.subdomain_information_dialog.share_box.save_for_easy_access' | translate
      }}</span>
    </div>
  </div>

  <div class="create-qr-code">
    <div class="text-container">
      <span class="heading">{{
        'tlc.members.subdomain_information_dialog.qr_code_box.heading' | translate
      }}</span>
      <span class="subheading">{{
        'tlc.members.subdomain_information_dialog.qr_code_box.subheading' | translate
      }}</span>
    </div>
    <rt-button
      #qrCodeDropdownTrigger="rtOverlayOrigin"
      rt-overlay-origin
      variant="tertiary"
      (click)="qrCodeDropdown.open = true"
    >
      <rt-icon name="qr-code-alt" />
      <span>{{
        'tlc.members.subdomain_information_dialog.qr_code_box.create_code' | translate
      }}</span>
    </rt-button>
  </div>
</rt-dialog-body>
<rt-dialog-footer>
  <rt-button variant="tertiary" (click)="generateFileAgain()">
    <rt-icon name="refresh" />
    <span>{{ 'tlc.members.subdomain_information_dialog.generate_file_again' | translate }}</span>
  </rt-button>
  <rt-button variant="primary" (click)="gotIt()">{{ 'tlc.common.got_it' | translate }}</rt-button>
</rt-dialog-footer>

<ng-template
  #qrCodeDropdown="rtConnectedOverlay"
  rt-connected-overlay
  [origin]="qrCodeDropdownTrigger"
  [positions]="dropdownPositions"
  [open]="qrCodeDropdownOpen()"
  [hasBackdrop]="true"
  (backdropClick)="qrCodeDropdown.open = false"
>
  <rt-dropdown [width]="DropdownWidth.Small" (click)="$event.preventDefault()">
    <div class="qr-code-container">
      <qr-code [size]="210" [value]="loginLink" />
      <span>{{
        'tlc.members.subdomain_information_dialog.qr_code_box.copy_instruction' | translate
      }}</span>
    </div>
  </rt-dropdown>
</ng-template>
